import { useApiContext } from 'contexts';

const useAPI = useApiContext;
export default useAPI;
